module.exports = __webpack_public_path__ + "static/home-money-transfer-6b93e04f411e69c15fe2992cfe6a3e35.png";